import { useState } from 'react';
import { Field } from 'formik';
import { TreeSelect } from 'antd';
import { Text } from '.';

export const TreeSelectDropdown = ({
  name,
  label,
  disabled,
  placeholder,
  options,
  value,
  onChange,
  className,
  popupClassName,
  showSearch,
  suffixIcon,
  bordered,
}) => {
  const [visible, setVisible] = useState(false);
  let hideTimeout = null;

  const handleMouseEnter = () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
    setVisible(true);
  };

  const handleMouseLeave = () => {
    hideTimeout = setTimeout(() => {
      setVisible(false);
    }, 250);
  };

  const handleOpenChange = (open) => {
    setVisible(open);
  };
  const renderTreeNodes = (data, parentKey = '') =>
    data.map((item, index) => {
      const nodeKey =
        item.value !== null && item.value !== undefined
          ? String(item.value)
          : `${parentKey}_${index}_null`;

      const className = `p-2 ${item.className}`;

      if (item.children) {
        return (
          <TreeSelect.TreeNode
            key={nodeKey}
            value={item.value}
            title={<span className={className}>{item.title}</span>}
            disabled={item.value}
            className={className}
          >
            {renderTreeNodes(item.children, nodeKey)}
          </TreeSelect.TreeNode>
        );
      }

      return (
        <TreeSelect.TreeNode
          key={nodeKey}
          value={item.value}
          title={<span className={className}>{item.title}</span>}
          className={className}
        />
      );
    });

  return (
    <Field name={name}>
      {({ form: { setFieldValue, setFieldTouched } }) => (
        <div
          className="w-full custom-select-component"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {label && (
            <Text type={'label'} htmlFor={name}>
              {label}
            </Text>
          )}
          <TreeSelect
            open={visible}
            id={name}
            variant="borderless"
            suffixIcon={suffixIcon}
            showSearch={showSearch}
            disabled={disabled}
            bordered={bordered}
            style={{ width: '100%' }}
            placeholder={placeholder}
            className={className || 'single-select '}
            popupClassName={popupClassName || ''}
            treeDefaultExpandAll={false}
            dropdownStyle={{
              minWidth: 'fit-content',
              zIndex: 999999999,
              padding: '10px 11px 6px 6px',
            }}
            value={value || null}
            onChange={(selectedValue, option) => {
              setFieldValue(name, selectedValue);
              if (onChange) {
                onChange(selectedValue, option);
              }
              setVisible(false);
            }}
            onOpenChange={handleOpenChange}
            onBlur={() => {
              setFieldTouched(name, true);
            }}
          >
            {renderTreeNodes(options)}
          </TreeSelect>
        </div>
      )}
    </Field>
  );
};
